<div class="content-card fixed">
  <p><b>Слайдер диапазона</b></p>

  <div class="card">
    <p><b>Время (range + 2 input, 00:00-24:00)</b></p>
    <div class="box">
      <pa-slider-range
        label="График ПВЗ"
        dataType="time"
        mode="range"
        [showInput]="true"
        [defaultValue]="{ lower: 9, upper: 21 }"
        [formControl]="timeRangeControl">
      </pa-slider-range>
    </div>
  </div>

  <div class="card">
    <p><b>Время (range без input)</b></p>
    <div class="box">
      <pa-slider-range
        label="Только ползунок"
        dataType="time"
        mode="range"
        [showInput]="false"
        [formControl]="timeNoInputControl">
      </pa-slider-range>
    </div>
  </div>

  <div class="card">
    <p><b>Числа (range + step)</b></p>
    <div class="box">
      <pa-slider-range
        label="Диапазон чисел"
        dataType="number"
        mode="range"
        [min]="0"
        [max]="100"
        [step]="5"
        [showInput]="true"
        [defaultValue]="{ lower: 20, upper: 80 }"
        [formControl]="numberRangeControl">
      </pa-slider-range>
    </div>
  </div>

  <div class="card">
    <p><b>Цена (range + input)</b></p>
    <div class="box">
      <pa-slider-range
        label="Диапазон цен"
        dataType="currency"
        mode="range"
        [min]="0"
        [max]="3000000"
        [step]="10000"
        [showInput]="true"
        [defaultValue]="{ lower: 0, upper: 3000000 }"
        [formControl]="currencyRangeControl">
      </pa-slider-range>
    </div>
  </div>

  <div class="card">
    <p><b>Single число (с input)</b></p>
    <div class="box">
      <pa-slider-range
        label="Процент"
        dataType="number"
        mode="single"
        [min]="0"
        [max]="100"
        [step]="1"
        [showInput]="true"
        [defaultValue]="45"
        [formControl]="singleNumberControl">
      </pa-slider-range>
    </div>
  </div>

  <div class="card">
    <p><b>Single время (без input)</b></p>
    <div class="box">
      <pa-slider-range
        label="Час открытия"
        dataType="time"
        mode="single"
        [showInput]="false"
        [defaultValue]="12"
        [formControl]="singleTimeControl">
      </pa-slider-range>
    </div>
  </div>

  <div class="card">
    <p><b>Disabled</b></p>
    <div class="box">
      <pa-slider-range
        label="Недоступный диапазон"
        dataType="currency"
        mode="range"
        [min]="100000"
        [max]="300000"
        [step]="5000"
        [showInput]="true"
        [disabled]="true"
        [formControl]="disabledRangeControl">
      </pa-slider-range>
    </div>
  </div>
</div>